export enum EStudentsQueryKeys {
  getStudents = "getStudents",
  getStudentById = "getStudentById",
  getArchivedStudents = "getArchivedStudents",
  restoreStudent = "restoreStudent",
}

export const STUDENTS_ENDPOINTS = {
  GET_ALL_STUDENTS: "/students",
  GET_ARCHIVED_STUDENTS: "/students/archived",
  RESTORE_STUDENT: (id: number) => `/students/${id}/restore`,
};
